/* Enchantmints Wholesale - AJAX add-to-cart with a confirmation toast.
   Any <form data-wsh-add> adds to the cart via /cart/add.js without leaving
   the page, shows a toast, and refreshes the header cart count.
   Progressive enhancement: without JS the form still posts normally. */
(function () {
  'use strict';
  if (window.__wshCartInit) return;
  window.__wshCartInit = true;

  function base() { return (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart'; }
  function addUrl() { return ((window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add') + '.js'; }
  function cartUrl() { return base() + '.js'; }

  var style = document.createElement('style');
  style.textContent =
    '#wsh-toast{position:fixed;left:50%;bottom:26px;transform:translateX(-50%) translateY(16px);z-index:2147483000;'
    + 'display:flex;align-items:center;gap:14px;max-width:calc(100vw - 32px);background:#2f3a2c;color:#f4f1ea;'
    + 'font-family:var(--sans,system-ui,-apple-system,sans-serif);font-size:15px;font-weight:600;padding:13px 18px;'
    + 'border-radius:12px;box-shadow:0 12px 34px rgba(20,30,15,.28);opacity:0;pointer-events:none;'
    + 'transition:opacity .22s ease,transform .22s ease;}'
    + '#wsh-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0);pointer-events:auto;}'
    + '#wsh-toast.is-error{background:#7d2f24;}'
    + '#wsh-toast a{color:#fff;text-decoration:underline;font-weight:800;white-space:nowrap;}';
  document.head.appendChild(style);

  var el, timer;
  function toast(html, isError) {
    if (!el) {
      el = document.createElement('div');
      el.id = 'wsh-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.className = isError ? 'is-error' : '';
    el.innerHTML = html;
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(timer);
    timer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function refreshCount() {
    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        var bubbles = document.querySelectorAll('.cart-count-bubble');
        Array.prototype.forEach.call(bubbles, function (b) {
          var span = b.querySelector('span[aria-hidden="true"]') || b.querySelector('span');
          if (span) span.textContent = count;
        });
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'wsh-cart' }); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = (e.target && e.target.closest) ? e.target.closest('form[data-wsh-add]') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]') || form.querySelector('button');
    var original = null;
    if (btn) { original = btn.innerHTML; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(addUrl(), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast((res.data && res.data.description) ? res.data.description : 'Sorry, that could not be added.', true);
        } else {
          var qty = (res.data && res.data.quantity) ? res.data.quantity : '';
          toast('<span>&#10003; Added to your cart' + (qty ? ' (' + qty + ')' : '') + '</span> <a href="' + base() + '">View cart</a>', false);
          refreshCount();
        }
      })
      .catch(function () { toast('Sorry, that could not be added.', true); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); if (original != null) btn.innerHTML = original; } });
  });
})();
